import { privateAxios } from 'services/api/privateAxios';

export const getActiveOrders = (
  page,
  pageSize = 10,
  search = null,
  orderBy = null,
  orderDirection = null,
) =>
  privateAxios({
    method: 'post',
    url: '/orderboard/activeorders',
    data: {
      page,
      pageSize,
      search,
      orderBy,
      orderDirection,
    },
  });
